import { Navigate, useParams } from 'react-router-dom';

import { FIRST_JOIN_STEP_ID, joinStepPath } from '../constants';

export function JoinFlowIndexRedirect() {
  const { orgId } = useParams<{ orgId: string }>();
  return orgId ? (
    <Navigate to={joinStepPath(orgId, FIRST_JOIN_STEP_ID)} replace />
  ) : (
    <Navigate to='/organizations' replace />
  );
}
